import { advancedFlowSchema_ } from "@redotech/redo-flows-common/advanced-flow-db-parser";
import * as z from "zod";

export const createAdvancedFlow = {
  name: "createAdvancedFlow" as const,
  input: z.object({
    newFlow: advancedFlowSchema_.omit({
      _id: true,
      createdAt: true,
      updatedAt: true,
      deletedAt: true,
      versionGroupId: true,
    }),
    setIndex: z.boolean(),
  }),
  output: z.object({ id: z.string() }),
};
